import { Action } from 'redux';
import { IItaAuctionResult } from '../../services';

export interface IResultState {
  showResultPanel?: boolean;
  itaAuctionResult?: IItaAuctionResult;
}

export enum ResultActionEnum {
  ShowResultPanel = '@@Result/Show_Result_Panel',
  HideResultPanel = '@@Result/Hide_Result_Panel'
}

export interface IShowResultPanelAction
  extends Action<typeof ResultActionEnum.ShowResultPanel> {
  state?: IResultState;
}
export interface IHideResultPanelAction
  extends Action<typeof ResultActionEnum.HideResultPanel> {
  state?: IResultState;
}

export type ResultActions =
  | IShowResultPanelAction
  | IHideResultPanelAction
  

